import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.css'
import './styles/global.scss'
import 'bootstrap-icons/font/bootstrap-icons.css'
import { MotionPlugin } from '@vueuse/motion'
import i18n from './i18n'

const app = createApp(App)
app.use(i18n)
app.use(MotionPlugin)
app.mount('#app')
